import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../../styles/profile/register.css';
import axios from 'axios';

function Body_register() {
    const [form, setForm] = useState({
        gender: '',
        firstName: '',
        lastName: '',
        email: '',
        emailRepeat: '',
        password: '',
        passwordRepeat: '',
        newsletter: false,
        adress: '',
        tel: ''
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.email !== form.emailRepeat) {
            alert("Die E-Mail-Adressen stimmen nicht überein.");
            return;
        }

        if (form.password !== form.passwordRepeat) {
            alert("Die Passwörter stimmen nicht überein.");
            return;
        }

        const formData = new FormData();
        formData.append('gender', form.gender || 'Liebes');
        formData.append('name', form.firstName);
        formData.append('last_name', form.lastName);
        formData.append('email', form.email);
        formData.append('password', form.password);
        formData.append('adress', form.adress);
        formData.append('tel', form.tel);

        try {
            const response = await fetch('https://nurleder.de/api/register/', {
                method: 'POST',
                body: formData,
                credentials: 'omit', // Wichtig: kein Cookie/CSRF benötigt
            });

            const data = await response.json();

            if (!response.ok) {
                console.error('Fehler:', data);
                if (data?.email?.length > 0) {
                    alert('⚠️ Diese E-Mail-Adresse ist bereits registriert.');
                } else {
                    alert('❌ Registrierung fehlgeschlagen.');
                }
                return;
            }

            alert('✅ Registrierung erfolgreich!');
            console.log(data);
            // window.location.href = "/login";
        } catch (err) {
            console.error('Netzwerkfehler:', err);
            alert('❌ Netzwerkfehler bei der Registrierung.');
        }
    };


    return (
        <form className="register-form" onSubmit={handleSubmit}>
            <h2>Registrieren</h2>

            <div className="gender-options">
                <label><input type="radio" name="gender" value="Herr" required onChange={handleChange} /> Herr</label>
                <label><input type="radio" name="gender" value="Frau" onChange={handleChange} /> Frau</label>
                <label><input type="radio" name="gender" value="Keine" onChange={handleChange} /> Keine Angabe</label>
            </div>

            <input type="text" name="firstName" placeholder="Vorname" required onChange={handleChange} />
            <input type="text" name="lastName" placeholder="Nachname" required onChange={handleChange} />
            <input type="email" name="email" placeholder="E-Mail" required onChange={handleChange} />
            <input type="email" name="emailRepeat" placeholder="E-Mail wiederholen" required onChange={handleChange} />

            <div className="password-field">
                <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Passwort (min. 8 Zeichen)"
                    minLength={8}
                    required
                    onChange={handleChange}
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
            </div>

            <div className="password-field">
                <input
                    type={showRepeatPassword ? "text" : "password"}
                    name="passwordRepeat"
                    placeholder="Passwort wiederholen"
                    minLength={8}
                    required
                    onChange={handleChange}
                />
                <span onClick={() => setShowRepeatPassword(!showRepeatPassword)}>
                    {showRepeatPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
            </div>

            <input type="text" name="adress" placeholder="Adresse" onChange={handleChange} />
            <input type="tel" name="tel" placeholder="Telefonnummer" onChange={handleChange} />

            <label className="newsletter">
                <input type="checkbox" name="newsletter" onChange={handleChange} />
                Ich möchte den Newsletter von nurleder.de abonnieren.
            </label>

            <button type="submit" className="submit-button" onClick={handleSubmit}>Weiter</button>
            <button type="button" className="cancel-button" onClick={() => window.history.back()}>
                Zurück
            </button>
        </form>
    );
}

export default Body_register;
